(function () {
    'use strict';

    var module = angular.module('uwAgenda.login');
    module.factory('RegistrationService', ['$http', RegistrationServiceFn]);

    /* service for the registration */
    function RegistrationServiceFn($http) {
        var service = {
            register: register,
            resetPassword: resetPassword,
            sendForgotPasswordEmail: sendForgotPasswordEmail
        };

        return service;

        /* register a new user */
        function register(user) {
            return $http.post('/api/users/registration', user);
        } // register

        function sendForgotPasswordEmail(email, userName, agendaOwnerId) {
            return $http({
                url: '/api/users/forgot-password',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                },
                method: 'POST',
                data: $.param({
                    email: email,
                    userName: userName,
                    agendaOwnerId: agendaOwnerId
                })
            });
        }
        function resetPassword(key, password, passwordRepeated, id) {
            return $http({
                url: '/api/users/reset-password',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                },
                method: 'POST',
                data: $.param({
                    key: key,
                    password: password,
                    passwordRepeated: passwordRepeated,
                    uniqueId: id
                })
            }).then(function(response) {
                return response.data;
            });
        }
    }
})();